'use client';

import clsx from 'clsx';
import ReactPortal from './react-portal';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

export interface DrawerProps {
  portalId: string;
  children?: React.ReactNode;
  open?: boolean;
  onClose?: (value?: boolean) => void;
  headerClassName?: string;
  title?: string;
  direction?: string;
  HeaderComponent?: React.ReactNode;
}

export const Drawer = ({
  portalId,
  children,
  open,
  onClose,
  headerClassName,
  title,
  HeaderComponent,
  direction = 'left'
}: DrawerProps) => {
  return (
    <ReactPortal wrapperId={portalId}>
      <Dialog open={open} onClose={onClose} className="relative z-10">
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden bg-primary-black/50">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
              <DialogPanel
                transition
                className={clsx(
                  'pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out sm:duration-700',
                  direction === 'left' && 'data-[closed]:translate-x-full',
                  direction === 'right' && 'data-[closed]:-translate-x-full'
                )}
              >
                <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                  {HeaderComponent ? (
                    HeaderComponent
                  ) : (
                    <div className={clsx(['p-6', headerClassName])}>
                      <div className="flex items-start justify-between">
                        <DialogTitle className="text-base font-semibold text-gray-900">
                          {title}
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => onClose()}
                            className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500"
                          >
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {children}
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </ReactPortal>
  );
};
